import { HStack } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const RewardRow = HStack.withConfig({
  _text: {
    color: getDesignToken('color-validated'),
  },
});
